import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Alert,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import FilterBar from "app/components/FilterBar";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
import Canvas from "app/components/Canvas";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import Draggable from "app/components/Draggable";
// import Toast from "react-native-root-toast";

import store from "app/redux/store";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

const CONSTELATE = false;
const WRAP = ENV.WEB;

// export default class Overview({navigation}) {
export default class Overview extends React.Component {
  constructor(props) {
    super(props);

    // let reviewDay = props.navigation.getParam('reviewDay', null);
    let { navigation, route } = this.props;
    let reviewDay = props.route?.params?.reviewDay;

    let { app, values, filters } = store.getState();
    let levelIds = valueHelpers.getLevelIds(values, false, filters.fromBottom);
    values = valueHelpers.filterToCurrentRevisions(values);
    // values = valueHelpers.sortByProgress(values, levelIds);
    values = filterHelpers.apply(values);
    let topLevel = valueHelpers.getTopLevel(levelIds);

    this.state = {
      values,
      topLevel,
      visibleLevels: [topLevel],
      levelIds,
      // loading: app.loading,
      loading: true,
      fetching: false,
      query: "",
      showOnlyStarred: false,
      showNotes: true,
      filters,
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      consellationKey: 0,
      scrollHeight: Dimensions.get("window").height,
      scrollHeight: null,
      ftue: false,
      ftueStep: 0,
      toasts: [],
      lastPressedId: null,
      demoStep: 0,
      reviewDay,
    };
  }

  async componentDidMount() {
    this.unsubscribe = store.subscribe(() => {
      let { app, values, filters } = store.getState();
      let levelIds = valueHelpers.getLevelIds(
        values,
        false,
        filters.fromBottom,
      );
      values = valueHelpers.filterToCurrentRevisions(values);
      // values = valueHelpers.sortByProgress(values, levelIds);
      values = filterHelpers.apply(values);
      let topLevel = valueHelpers.getTopLevel(levelIds);
      this.setState({
        loading: app.loading,
        filters,
        // values,
        levelIds,
        topLevel,
        visibleLevels:
          this.state.visibleLevels.length == 1
            ? [topLevel]
            : this.state.visibleLevels,
      });
    });

    // focus
    this.props.navigation.addListener("focus", this.handleFocus);

    // let fetchedValues = await valueActions.indexLite();
  }

  componentWillUnmount() {
    this.props.navigation.removeListener("focus");
    this.unsubscribe();
  }

  handleFocus = () => {
    console.log("FOUCS");
    let reviewDay = this.props.route?.params?.reviewDay;
    this.setState({ reviewDay });
  };

  resetHorizontalScrollers = () => {
    let { values } = this.state;
    let topLevel = valueHelpers.getTopLevel(values);
    let levels = this.levelsArray(values, topLevel);
    let includeNegative = !!values.find((v) => v.level < 0);
    levels.forEach((level) => {
      if (includeNegative) level += 1;
      let ref = this[`scrollerRefLevel${level}`];
      console.log(ref);
      if (ref) ref.scrollTo({ x: 0, y: 0, animated: true });
    });
  };

  render() {
    let {
      values,
      fetching,
      query,
      hideComplete,
      showSnoozed,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      redrawKey,
      scrollHeight,
      loading,
      showFocus,
      reviewDay,
    } = this.state;

    return (
      <View
        style={[styles.container]}
        key={redrawKey}
        ref={(ref) => (this.wrapperRef = ref)}
        onLayout={({ nativeEvent }) => {
          if (this.wrapperRef) {
            this.wrapperRef.measure((x, y, width, height, pageX, pageY) => {
              // console.log(`warpper: w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
              this.setState({ scrollHeight: height });
            });
          } else console.log(`no wrapper ref`);
        }}
      >
        {/*
      <View key={redrawKey} style={{flex: 1}}><ScrollView contentContainerStyle={styles.container}>
      */}
        <StatusBar style="auto" />
        {ENV.WEB && (!!showFocus || true) && (
          <Canvas lines={lines} scrollHeight={scrollHeight} />
        )}

        <FilterBar
          temporary={!!reviewDay}
          filters={
            !!reviewDay ? filterHelpers.defaultReviewDayFilters() : undefined
          }
          navigation={this.props.navigation}
        />

        <View
          style={{
            flex: 1,
            // borderWidth: 5, borderColor: 'red'
          }}
        >
          {loading && false ? <ActivityIndicator /> : this.renderLevels()}
        </View>

        <View />
      </View>
    );
  }

  renderLevels = () => {
    let {
      values,
      topLevel,
      levelIds,
      fetching,
      query,
      filters,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      consellationKey,
      ftue,
      toasts,
      ftueStep,
      demoStep,
      showFocus,
      filterKey,
      visibleLevels,
    } = this.state;
    let { fromBottom } = filters;

    let levelArray = Object.keys(levelIds);
    if (fromBottom) levelArray = levelArray.reverse();

    let includeNegative = !!values.find((v) => v.level < 0);

    return (
      <ScrollView
        onContentSizeChange={(width, height) => {
          // console.warn(`scrollHeight: ${height}, windowHeight: ${Dimensions.get('window').height}`);
          // let scrollHeight = Math.max(height, Dimensions.get('window').height)
          // let windowHeight = Dimensions.get('window').height
          let scrollHeight = height;
          // if(scrollHeight < windowHeight) scrollHeight = height ???
          // scrollHeight = windowHeight
          // this.setState({scrollHeight})
        }}
        ref={(ref) => (this.scrollerRef = ref)}
        onContentSizeChange={(contentWidth, contentHeight) => {
          // if(this.scrollerRef) this.scrollerRef.scrollToEnd({animated: true})
        }}
        // scrollEventThrottle={100}
        // onScroll={(event) => {
        //   let scrollPos = event.nativeEvent.contentOffset.y
        //   console.log(scrollPos, scrollPos + Dimensions.get('window').height)
        // }}
        style={{
          height: 1,
          // flex: 1,
          // paddingBottom: sizes.giant*5,
          // borderWidth: 1, borderColor: 'red',
        }}
        contentContainerStyle={{
          // paddingTop: sizes.giant, paddingBottom: sizes.giant*2,
          // borderWidth: 1, borderColor: 'white',
          flexGrow: 1,
          // flex: 1,
          // justifyContent: 'space-around',
          // justifyContent: 'center',
          // borderWidth: 5, borderColor: 'green',
        }}
      >
        <TouchableWithoutFeedback
          onPress={() => {
            this.hoverOut();
            this.setState({ quickActionsId: null });
          }}
          accessible={false}
        >
          <View
            style={{
              ...StyleSheet.absoluteFillObject,
              bottom: -100,
              opacity: 0,
            }}
          />
        </TouchableWithoutFeedback>

        {levelArray.map((level) => {
          // if (!visibleLevels.includes(parseInt(level))) return;

          //{Object.keys(levelIds).map(level => {
          let levelValues = values.filter((v) =>
            levelIds[level].includes(v.id),
          ); //.reverse()
          // {levels.map(level => {
          // {!fetching && (ENV.WEB ? levels : levels.splice(0,2)).map(level => {
          // let levelValues = values.filter(v => v.level == level) //.reverse()
          if (includeNegative) level += 1;

          let levelScaling = level / (topLevel || 1);
          if (!fromBottom) levelScaling = (topLevel - level) / topLevel;

          if (includeNegative) levelScaling = level / (topLevel + 1);
          // levelScaling = 1
          let scalePerc = 1.0 + 1 * levelScaling;
          scalePerc = 1;
          let distance = 0.5 * levelScaling;
          distance = 0;

          let levelScale = 1.0 + 0.4 * levelScaling;
          let maxSize = 100 * levelScale;
          let minSize = 90 * levelScale;
          let size = maxSize;
          let minWrapperSize = maxSize / 2 + maxSize / 8;
          minWrapperSize = ENV.WEB ? maxSize * 1.25 : maxSize * 1.1;
          // if(!ENV.WEB) minWrapperSize = (maxSize/2)+(maxSize*0.4)
          let gutterSize = (size / 2) * screenRatio * 0.2 * 3;
          let outterSize = size + gutterSize;
          let maxOutterSize = outterSize;
          if (!ENV.WEB) maxOutterSize = size;

          return (
            <View
              key={`level-${level}`}
              style={[
                styles.row,
                { minHeight: maxSize },
                // {zIndex: level, overflow: 'visible'},
                // {borderWidth: 2, borderColor: 'green',},
              ]}
            >
              <ScrollView
                key={`level-${level}`}
                ref={(ref) => (this[`scrollerRefLevel${level}`] = ref)}
                style={[
                  styles.rowScroller,
                  WRAP ? { flexWrap: "wrap", flex: 1 } : null,
                  // {zIndex: level, overflow: 'visible'},
                  // {borderWidth: 1, borderColor: 'purple',},
                ]}
                contentContainerStyle={[
                  styles.rowScrollerContainer,
                  // {paddingLeft: !!minWrapperSize ? minWrapperSize/7 : 0},
                  { paddingLeft: sizes.large },
                  // {borderWidth:1, borderColor:'white',},
                  WRAP ? { flexWrap: "wrap", flex: 1 } : null,
                ]}
                horizontal
                scrollEventThrottle={100}
                onScroll={(event) => {
                  // let scrollPos = event.nativeEvent.contentOffset.x
                  // redraw consellations
                  if (!!selectedValue) {
                    // this.setState({consellationKey: consellationKey+1})
                  }
                }}
              >
                <TouchableWithoutFeedback
                  onPress={() => {
                    this.hoverOut();
                    this.setState({ quickActionsId: null });
                  }}
                  accessible={false}
                >
                  <View
                    style={[
                      styles.rowScrollerContent,
                      WRAP ? { flexWrap: "wrap", flex: 1 } : null,
                      // ENV.DEV ? {flex:1} : null,
                      // {borderWidth: 1, borderColor: 'red'},
                    ]}
                  >
                    {/*<Text>{topLevel-level}</Text>*/}
                    <Text>{level}</Text>

                    {levelValues.map((value, i) => (
                      <Hoverable
                        accessible={false}
                        key={i}
                        // onHoverIn={() => this.hoverIn(value)}
                        // onHoverOut={() => this.hoverOut(value)}
                      >
                        {(isHovered) => {
                          // if(!!selectedValue) isHovered = false

                          // let selected = !!selectedValue && selectedValue.id == value.id
                          let selected = familyIds.includes(value.id);

                          // size = (selected || isHovered) ? maxSize : minSize
                          size = isHovered ? maxSize : minSize;
                          size = maxSize;

                          gutterSize = (size / 2) * screenRatio * 0.2 * 3;
                          outterSize = size + gutterSize;

                          let isFtuePrompt =
                            typeof value.id == "string" &&
                            value.id.includes("ftue");

                          let filler = false;
                          if (ftue && isFtuePrompt) {
                            if (level == 0 && ftueStep < 1) {
                              filler = true;
                            } else if (level == 2 && ftueStep < 2) {
                              filler = true;
                            }
                          }

                          let baseSize = size;

                          if (!isHovered && i > 7 && WRAP) {
                            // if(i>7 && WRAP){
                            // size = Math.max(10, size-(5*(i-7)) )
                          }

                          if (isHovered) {
                            let scaleFactor = Math.max(1.1, 100 / size);
                            scalePerc = scaleFactor;
                          } else {
                            scalePerc = 1;
                          }

                          return (
                            <TouchableWithoutFeedback
                              onPress={() => {
                                this.hoverOut();
                                this.setState({ quickActionsId: null });
                                if (ftue) this.nextFtueStep();
                              }}
                              accessible={false}
                            >
                              <View
                                style={[
                                  styles.valueWrapper,
                                  {
                                    minWidth: minWrapperSize,
                                    // minHeight: maxOutterSize,
                                    minHeight: size * 1.4,
                                    zIndex:
                                      selected || isHovered
                                        ? 9999
                                        : levelValues.length - i,
                                    // borderWidth: 1, borderColor: 'white',
                                  },
                                  // selected || isHovered ? {marginHorizontal: minWrapperSize/2} : null,
                                  {
                                    transform: [
                                      { scale: scalePerc },
                                      // {rotateX: `-20deg`},
                                    ],
                                    opacity:
                                      !!familyIds.length &&
                                      !familyIds.includes(value.id)
                                        ? 0.2
                                        : 1,
                                    // opacity: isHovered || familyIds.includes(value.id) ? 1 : (
                                    //   !!familyIds.length && !familyIds.includes(value.id) ? 0.2 : 1
                                    // ),
                                    // borderWidth: 1, borderColor: 'green',
                                  },
                                ]}
                              >
                                <Draggable
                                // onDragStart={() => this.setState({draggingValue: val})}
                                // onDragMove={coords => this.handleDragMove(coords)}
                                // onDragEnd={coords => this.handleDragEnd(coords)}
                                // freezeOnRelease={!!overlappedValue}
                                >
                                  {(isDragging) => {
                                    return (
                                      <Value
                                        // childrenRing
                                        size={size}
                                        value={
                                          ftue
                                            ? {
                                                ...value,
                                                filler,
                                              }
                                            : value
                                        }
                                        key={`value-${value.id}-${consellationKey}`}
                                        ref={(ref) => {
                                          this[`val_${value.id}`] = ref;
                                        }}
                                        // selected={selected || (typeof value.id == 'string' && value.id.includes('ftue'))}
                                        selected={
                                          selectedValue?.id == value.id ||
                                          (typeof value.id == "string" &&
                                            value.id.includes("ftue"))
                                        }
                                        onDeselect={() => this.hoverOut(value)}
                                        onLongPress={
                                          isFtuePrompt ||
                                          (value.id == 1 && demoStep < 3)
                                            ? () => null
                                            : undefined
                                        }
                                        onPress={() => {
                                          this.setState({
                                            lastPressedId: value.id,
                                          });
                                          if (ftue) {
                                            if (!ftueStep) {
                                              this.nextFtueStep();
                                              return;
                                            } else {
                                              if (
                                                toasts[toasts.length - 1]
                                                  ?.tutorial
                                                  ?.hideOnPressPrompt &&
                                                isFtuePrompt
                                              ) {
                                                // toasts.forEach((t) =>
                                                // Toast.hide(t.toast)
                                                // );
                                                // this.setState({ftueStep: ftueStep+1})
                                              } else if (
                                                value.id == 1 ||
                                                isFtuePrompt
                                              ) {
                                                this.nextFtueStep();
                                                return;
                                              }
                                            }
                                          }
                                          if (isFtuePrompt) {
                                            let text = value.text.startsWith(
                                              "Create a custom",
                                            )
                                              ? ""
                                              : value.text;
                                            RootNavigation.navigate("Create", {
                                              ...value,
                                              text,
                                              ftue: true,
                                            });
                                            return;
                                          }
                                          if (
                                            ftue &&
                                            value.id == 1 &&
                                            demoStep < 3
                                          ) {
                                            valueActions.confirm(
                                              "Ok",
                                              "",
                                              `Welcome!`,
                                              "Begin by filling out one of the prompts, or creating your own.",
                                              false,
                                            );
                                            return;
                                          }

                                          // if(ENV.WEB || selected){
                                          if (!!quickActionsId) {
                                            this.setState({
                                              quickActionsId: null,
                                            });
                                          }
                                          // else if(true) {
                                          else if (false) {
                                            RootNavigation.navigate("Value", {
                                              id: value.id,
                                            });
                                          } else if (
                                            !!selectedValue &&
                                            selectedValue.id == value.id
                                          ) {
                                            RootNavigation.push("Value", {
                                              id: value.id,
                                            });
                                          } else if (selected) {
                                            this.hoverIn(value);
                                          } else if (!!selectedValue) {
                                            this.hoverOut();
                                          } else {
                                            this.hoverIn(value);
                                          }
                                        }}
                                        style={
                                          [
                                            // {position: 'absolute', left: -outterSize/2, top: -outterSize/2 },
                                            // isHovered || i<7 || familyIds.includes(value.id) ? null : {
                                            //   transform: [{
                                            //     scale: (0.9 - (0.025*(i-6))),
                                            //   }],
                                            // },
                                            // isHovered || i>(levelValues.length-6) || familyIds.includes(value.id) ? null : {
                                            //   transform: [{
                                            //     scale: (0.9 - (0.025*(levelValues.length-6-i))),
                                            //   }],
                                            // opacity: (0.9 - (0.025*(i-6))),
                                            // },
                                            // familyIds.includes(value.id) ? {borderColor: colors.active} : null,
                                          ]
                                        }
                                        distance={
                                          familyIds.includes(value.id)
                                            ? 0
                                            : distance
                                        }
                                        maxWidth={250}
                                        filterToFamily={() =>
                                          this.handleFilterToFamily(value)
                                        }
                                        onUpdate={(val) =>
                                          this.handleUpdate(val)
                                        }
                                        showQuickActions={
                                          quickActionsId == value.id
                                        }
                                        onShowQuickActions={() =>
                                          this.setState({
                                            quickActionsId: value.id,
                                          })
                                        }
                                        onHideQuickActions={() =>
                                          this.setState({
                                            quickActionsId: null,
                                          })
                                        }
                                        onSelect={
                                          ENV.WEB
                                            ? () => this.hoverIn(value)
                                            : undefined
                                        }
                                        hiddenIds={this.state.hiddenIds}
                                        todoIds={this.state.todoIds}
                                        focusIds={this.state.focusIds}
                                        showFocusRing={!!showFocus}
                                      />
                                    );
                                  }}
                                </Draggable>
                              </View>
                            </TouchableWithoutFeedback>
                          );
                        }}
                      </Hoverable>
                    ))}
                  </View>
                </TouchableWithoutFeedback>
              </ScrollView>
            </View>
          );
        })}
      </ScrollView>
    );
  };

  updateValuesToRender = (values = null) => {
    if (values == null) values = this.state.values;
    let valuesToRender = valueHelpers.onlyRecentRevisions(values);
    if (this.filterBar)
      valuesToRender = this.filterBar.applyFilters(valuesToRender);
    // valuesToRender = valueHelpers.sortByTimeline(valuesToRender)
    this.setState({ valuesToRender });
  };

  handleUpdate = async (val, newPrefs = null) => {
    let values = this.state.values.map((v) =>
      v.id == val.id ? { ...v, ...val } : v,
    );

    // values = valueHelpers.sortByTimeline(values)
    storageActions.saveItem("values", values);
    // values = valueHelpers.onlyRecentRevisions(values)
    // if(this.filterBar) values = this.filterBar.applyFilters(values)
    // values = valueHelpers.sortByTimeline(values)
    this.updateValuesToRender(values);
    // values = valueHelpers.applyLevels(values)

    console.log("handleupdate:", val, newPrefs);
    // if(!!newPrefs){
    //   this.setState({...newPrefs})
    // }
    let pref = await prefActions.get(true);
    await this.setState({
      // values,
      query: "",
      hiddenIds: pref.hidden_ids,
      todoIds: pref.todo_ids,
      focusIds: pref.focus_ids,
      // filters: pref.filters,
      query: "",
    });
    await this.setState({ values });
  };

  levelsArray = (values, topLevel) => {
    // let { fromBottom } = this.state
    // let length = topLevel+1
    // let includeNegative = !!values.find(v => v.level < 0)
    // if(includeNegative) length += 1
    // let levels = new Array(length).fill(0).map((x,i) => includeNegative ? i-1 : i)
    // if(fromBottom) levels = levels.reverse()
    // console.log(topLevel, levels)
    // return levels
  };

  handleClickValue = (value) => {
    let { values } = this.state;
    value.clicked = true;
    values.map((v) => (v.id == value.id ? value : v));
    this.setState({ values });
  };

  handleFilterToFamily = (value) => {
    let fam = [value];

    let children = values.filter(
      (v) => v.parent_ids && v.parent_ids.includes(value.id),
    );
    fam = [...fam, ...children];

    let grandchildren = values.filter(
      (v) =>
        children.filter((c) => !!c.child_ids && c.child_ids?.includes(v.id))
          .length > 0 && fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...grandchildren];

    let parents = values.filter(
      (v) =>
        !!v.child_ids &&
        v.child_ids?.includes(value.id) &&
        fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...parents];

    let grandparents = values.filter(
      (v) =>
        parents.filter((p) => p.parent_ids && p.parent_ids.includes(v.id))
          .length > 0 && fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...grandparents];

    this.setState({ values: fam });
  };

  constelate = (value, upwards = true) => {
    return;
    let lines = [];
    if (!!!this[`val_${value.id}`]) return lines;
    // console.log(this[`val_${value.id}`].state.absX, this[`val_${value.id}`].state.absY)
    let origin = [
      this[`val_${value.id}`].state.absX,
      this[`val_${value.id}`].state.absY,
      // this[`val_${value.id}`].state.absX ,
      // this[`val_${value.id}`].state.absY,
      value.id,
    ];

    let targetIds = upwards ? value.parent_ids : value.child_ids;
    // console.log(value, upwards, targetIds)
    // return []
    let targetXs = [];
    targetIds.forEach((id) => {
      if (!!this[`val_${id}`]) {
        let pointX = this[`val_${id}`].state.absX;
        if (targetXs.includes(pointX)) pointX += 10;
        targetXs.push(pointX);
        let pointY = this[`val_${id}`].state.absY;
        let point = [pointX, pointY, id];
        lines.push([origin, point]);
      }
    });
    return lines;
  };

  hoverIn = async (value) => {
    // this.setState({pendingSelectedValue: value})
    // await new Promise(resolve => setTimeout(resolve, 2000));
    // if(this.state.pendingSelectedValue?.id != value.id) return
    console.log(value);
    let { values } = this.state;
    let familyIds = valueHelpers.getFamily(value).map((v) => v.id);
    // let familyIds = [value.id]
    let lines = [];

    // if(CONSTELATE)
    //   lines = [...lines, ...this.constelate(value, true)]

    // // let familyIds = textHelpers.getFamilyIds(value)

    // let parentIds = value.parent_ids
    // while(parentIds.length){
    //   familyIds = [...familyIds, ...parentIds]
    //   let parents = values.filter(v => parentIds.includes(v.id))
    //   parentIds = parents.map(v => v.parent_ids).flat()
    //   if(CONSTELATE)
    //     parents.forEach(val => lines = [...lines, ...this.constelate(val, true)])
    // }

    // if(CONSTELATE)
    //   lines = [...lines, ...this.constelate(value, false)]

    // let childIds = value.child_ids
    // while(childIds.length){
    //   familyIds = [...familyIds, ...childIds]
    //   let children = values.filter(v => childIds.includes(v.id))
    //   childIds = children.map(v => v.child_ids).flat()
    //   if(CONSTELATE)
    //     children.forEach(val => lines = [...lines, ...this.constelate(val, false)])
    // }

    // familyIds = [...new Set(familyIds)]
    await this.setState({
      familyIds,
      lines,
      selectedValue: value,
      quickActionsId: null,
    });
    // this.updateValuesToRender()
  };

  hoverOut = async (value = null) => {
    await this.setState({
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
    });
    // this.updateValuesToRender()
  };

  nextFtueStep = async () => {
    let { toasts, ftueStep, values } = this.state;
    if (!!toasts.length) {
      if (toasts[toasts.length - 1].tutorial.hideOnPressPrompt) {
        return;
      } else if (ftueStep == 13) {
        // if (toasts.length) toasts.forEach((t) => Toast.hide(t.toast));
        this.setState({ ftue: false });
        storageActions.saveItem("ftue", false);
        storageActions.saveItem("ftueStep", 0);
        return;
      } else if (ftueStep >= 6) {
        let v = values.find((v) => v.id == 2);
        v = await valueActions.createProgress(v, null, null, false);
        values = await valueActions.updateValues(v, values);
        await this.setState({ values });
      }

      ftueStep += 1;
      await this.setState({ ftueStep });
      await storageActions.saveItem("ftueStep", ftueStep);
    }
    this.ftueToast();
  };

  ftueToast = () => {
    let { toasts, ftueStep } = this.state;

    let tutorial = ftueHelpers.tutorial()[ftueStep];
    if (!!!tutorial) return;

    if (tutorial.clearPrevious !== false) {
      // if (this.state.toasts.length)
      //   this.state.toasts.forEach((t) => Toast.hide(t.toast));
    }

    let message = tutorial.message;
    let hideOnPress = tutorial.hideOnPress;
    let position = tutorial.position || -100;

    toasts.push({
      tutorial,
      // toast: Toast.show(message, {
      //   duration: 0,
      //   position,
      //   delay: tutorial.delay,
      //   backgroundColor: colors.foreground,
      //   textColor: colors.empty,
      //   hideOnPress,
      //   opacity: 0.85,
      //   onPress: async () => {
      //     // console.log(tutorial)
      //     this.nextFtueStep();
      //   },
      //   onShow: () => {
      //     // calls on toast\`s appear animation start
      //   },
      //   onShown: () => {
      //     // calls on toast\`s appear animation end.
      //   },
      //   onHide: () => {
      //     // calls on toast\`s hide animation start.
      //   },
      //   onHidden: () => {
      //     // calls on toast\`s hide animation end.
      //     // this.ftueToast(step+1)
      //   },
      // }),
    });
    this.setState({ toasts });
  };

  showToast = (message, duration) => {
    //   if (this.toast) Toast.hide(this.toast);
    //   this.toast = Toast.show(message, {
    //     duration: Toast.durations.LONG,
    //     // position: Toast.positions.TOP,
    //     position: ENV.WEB ? 150 : 150,
    //     shadow: true,
    //     animation: true,
    //     hideOnPress: true,
    //     backgroundColor: colors.foreground,
    //     textColor: colors.empty,
    //     delay: 0,
    //     onShow: () => {
    //       // calls on toast\`s appear animation start
    //     },
    //     onShown: () => {
    //       // calls on toast\`s appear animation end.
    //     },
    //     onHide: () => {
    //       // calls on toast\`s hide animation start.
    //     },
    //     onHidden: () => {
    //       // calls on toast\`s hide animation end.
    //     },
    //   });
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    // backgroundColor: '#111',
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    // padding: sizes.large,
    // borderColor:'white',borderWidth:1,
  },
  rowScroller: {
    flex: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  rowScrollerContainer: {
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: "center",
    // alignItems: 'center',
    alignItems: "stretch",
    // paddingTop: sizes.base,
    // flexWrap: 'wrap',
    // borderBottomWidth: 1, borderColor: colors.trim,
  },
  rowScrollerContent: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  valueWrapper: {
    flex: 1,
    alignSelf: "stretch",
    // flexGrow: 0,
    justifyContent: "center",
    alignItems: "center",
    // borderColor: 'red', borderWidth: 2,
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});
